import { render, staticRenderFns } from "./AdminVerticalNavMenu.vue?vue&type=template&id=a3f4a55a&scoped=true"
import script from "./AdminVerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./AdminVerticalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminVerticalNavMenu.vue?vue&type=style&index=0&id=a3f4a55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f4a55a",
  null
  
)

export default component.exports